import { useEffect, useRef } from 'react';
import { Container } from './styled';

export const RadioButton = (props) => {

    const { id, label, type, onChange, checked, className, ...rest } = props;

    const checkRef = useRef(null);

    useEffect(() => {
        checkRef.current.checked = checked;
    }, [checked])

    return (
        <Container className={className}>
            <input id={id} ref={checkRef} onChange={(e) => onChange(e.target.value)} name={label} type='radio'{...rest} />
            <span htmlFor={id}>{label}</span>
        </Container>
    );

};
